import React from 'react';
import { styled } from '@compiled/react';

import { LoadableAfterPaint } from '@confluence/loadable';

export const ContentTypeClassificationLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentTypeClassification" */ '../src/ContentTypeClassification/ContentTypeClassification'
			)
		).ContentTypeClassification,
	loading: (props) => {
		const { contentClassificationMetadata } = props;
		const { hasNoClassification } = contentClassificationMetadata;
		const shouldNotRenderLoader = hasNoClassification;
		if (shouldNotRenderLoader) return null;
		return React.createElement(
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
			styled.div({
				height: '24px',
			}),
			{},
			'',
		);
	},
});

export { ContentTypeClassification } from '../src/ContentTypeClassification/ContentTypeClassification';
